/**
 * market-restriction.js
 * ---------------------
 * Author: Julian van Wijk @ evitavonni
 * Created: 26/06/2025
 *
 * Purpose:
 * - Restricts customers in the 'default' Shopify Market from ordering non-sample items.
 *
 * How it works:
 * - Checks for the global `window.defaultMarket` flag (set via Liquid in the cart template).
 * - Filters out any items that are NOT of type 'FB-sample'.
 * - Removes these items from the cart via the Cart API.
 * - Displays a styled modal popup explaining the restriction.
 *
 * Dependencies:
 * - Requires `window.cartItems` to be available (set in the cart template via Liquid).
 * - Requires `window.defaultMarket` to be set in Liquid.
 * - Requires the 'ev-popup-modal' snippet to be rendered in the DOM.
 */

// Helper: Show styled popup modal (requires 'ev-popup-modal' snippet in DOM)
function showPopup({ heading = 'Notice', message = '' }) {
  const modal = document.getElementById('marketModal');
  if (!modal) return;

  modal.querySelector('.ev-modal-heading').textContent = heading;
  modal.querySelector('.ev-modal-message').textContent = message;
  modal.style.display = 'flex';

  const closeBtn = modal.querySelector('.ev-modal-close');
  closeBtn.addEventListener('click', () => modal.style.display = 'none');

  modal.addEventListener('click', (e) => {
    if (e.target === modal) modal.style.display = 'none';
  });
}

document.addEventListener('DOMContentLoaded', function () {
  if (!window.defaultMarket) return; // Skip logic if user is not in 'default' market

  const blockedItems = window.cartItems?.filter(
    item => item.productType?.toLowerCase() !== 'fb-sample'
  ) || [];

  if (blockedItems.length === 0) return;

  console.log('[RegionBlock] Removing non-sample items from cart (default market)…');

  Promise.all(
    blockedItems.map(item =>
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: 0 })
      })
    )
  )
    .then(() => {
      showPopup({
        heading: 'Market Restriction',
        message: 'Only samples can be ordered in your region. Other items have been removed.'
      });
      // Optional delay to allow reading before reload
      setTimeout(() => window.location.reload(), 3000);
    })
    .catch(error => {
      console.error('[RegionBlock] Error removing restricted items:', error);
    });
});